define("shared/components/shared/mobile/open-app", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@glimmer/component", "shared/utils/platform-check", "shared/utils/redirect"], function (_exports, _component, _templateFactory, _object, _component2, _platformCheck, _redirect) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@glimmer/component",0,"shared/utils/platform-check",0,"shared/utils/redirect"eaimeta@70e063a35619d71f

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Ui::Button
    @onClick={{this.openApp}}
    @variant={{if @type @type "outline"}}
    class={{if @class @class "o-—btn o--btn--block o--btn--primary"}}
    type="button"
    ...attributes
  >
    {{#if (has-block)}}
      {{yield}}
    {{else}}
      {{t "schedule.open_app"}}
    {{/if}}
  </Shared::Ui::Button>
  */
  {
    "id": "zjz8I7Hs",
    "block": "[[[8,[39,0],[[16,0,[52,[30,1],[30,1],\"o-—btn o--btn--block o--btn--primary\"]],[24,4,\"button\"],[17,2]],[[\"@onClick\",\"@variant\"],[[30,0,[\"openApp\"]],[52,[30,3],[30,3],\"outline\"]]],[[\"default\"],[[[[1,\"\\n\"],[41,[48,[30,4]],[[[1,\"    \"],[18,4,null],[1,\"\\n\"]],[]],[[[1,\"    \"],[1,[28,[35,4],[\"schedule.open_app\"],null]],[1,\"\\n\"]],[]]]],[]]]]]],[\"@class\",\"&attrs\",\"@type\",\"&default\"],false,[\"shared/ui/button\",\"if\",\"has-block\",\"yield\",\"t\"]]",
    "moduleName": "shared/components/shared/mobile/open-app.hbs",
    "isStrictMode": false
  });

  let OpenAppComponent = (_class = class OpenAppComponent extends _component2.default {
    get isIos() {
      return (0, _platformCheck.isIos)(navigator);
    }

    get appUrl() {
      return this.isIos ? 'https://apps.apple.com/ca/app/later/id784907999' : 'https://play.google.com/store/apps/details?id=me.latergram.latergramme';
    }

    openApp() {
      setTimeout(() => {
        window.open(this.appUrl, '_blank');
      }, 25);
      (0, _redirect.default)('later://');
    }

  }, (_applyDecoratedDescriptor(_class.prototype, "openApp", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "openApp"), _class.prototype)), _class);
  _exports.default = OpenAppComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, OpenAppComponent);
});